import apiClient from './apiClient';

const payrollService = {
  /**
   * Get all payroll records
   */
  getAll: async (page = 1, limit = 10, filters = {}) => {
    const params = new URLSearchParams({ page, limit });

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        params.append(key, value);
      }
    });

    const response = await apiClient.get(`/payroll?${params}`);
    return response.data;
  },

  /**
   * Generate payslip for an employee
   */
  generatePayslip: async (employeeId, month, year) => {
    const response = await apiClient.post('/payroll/generate', {
      employeeId,
      month,
      year
    });
    return response.data;
  },

  /**
   * Get payslip details with full information
   */
  getPayslipWithDetails: async (id) => {
    const response = await apiClient.get(`/payroll/details/${id}`);
    return response.data;
  },

  /**
   * Update payslip amounts
   */
  updatePayslip: async (id, updates) => {
    const response = await apiClient.put(`/payroll/${id}`, updates);
    return response.data;
  },

  /**
   * Process payroll
   */
  process: async (month, year, templateId) => {
    const response = await apiClient.post('/payroll/process', {
      month,
      year,
      templateId
    });
    return response.data;
  },

  /**
   * Get employee payslips
   */
  getEmployeePayslips: async (employeeId, year = null, month = null) => {
    let url = `/payroll/payslips/${employeeId}`;
    const params = new URLSearchParams();

    if (year) {
      params.append('year', year);
    }

    if (month) {
      params.append('month', month);
    }

    const query = params.toString();
    if (query) {
      url += `?${query}`;
    }

    const response = await apiClient.get(url);
    return response.data;
  },

  /**
   * Get payslip details
   */
  getPayslipDetails: async (id) => {
    const response = await apiClient.get(`/payroll/payslips/${id}`);
    return response.data;
  },

  /**
   * Approve payslip
   */
  approvePayslip: async (id) => {
    const response = await apiClient.put(`/payroll/${id}/approve`);
    return response.data;
  }
};

export default payrollService;
